import { Box, Stack, Typography, useTheme } from '@mui/material';
import { ThumbsUp } from 'lucide-react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { H5, Small } from '../../components/Typography';
import FlexBox from '../../components/flexbox/FlexBox';
import ToggleButton from './ToggleButton';

// Dataset for "이달의 인기 질문" (This Month's Popular Questions)
const data = [
  {
    id: 1,
    question:
      '이거진짜 히트에요 님들 꼭 받아가세요 이거진짜 히트에요 님들 꼭 받아가세요',
    likes: 567,
    path: '/naver/callmetellme/community/community-detail',
  },
  {
    id: 2,
    question: '이거진짜 히트에요 님들 꼭 받아가세요',
    likes: 331,
    path: '/naver/callmetellme/community/community-detail',
  },
  {
    id: 3,
    question: '이거진짜 히트에요 님들 꼭 받아가세요',
    likes: 86,
    path: '/naver/callmetellme/community/community-detail',
  },
  {
    id: 4,
    question: '이거진짜 히트에요 님들 꼭 받아가세요',
    likes: 50,
    path: '/naver/callmetellme/community/community-detail',
  },
  {
    id: 5,
    question: '이거진짜 히트에요 님들 꼭 받아가세요',
    likes: 41,
    path: '/naver/callmetellme/community/community-detail',
  },
];

const tabs = [
  { id: '인기도순', label: '인기도순' },
  { id: '댓글순', label: '댓글순' },
  { id: '공유순', label: '공유순' },
];

const MonthlyPopularQuestions = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const [activeTab, setActiveTab] = useState('인기도순');
  return (
    <Box
      sx={{
        backgroundColor: '#ffffff',
        borderRadius: '24px',
        padding: '20px',
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
        border: '1px solid #f0f0f0',
      }}
    >
      <FlexBox
        sx={{
          alignItems: 'center',
          paddingBottom: '16px',
        }}
      >
        <img
          src={'/static/icons/medal.svg'}
          alt="money"
          style={{ width: '24px', height: '24px', marginRight: '8px' }}
        />
        <H5>이달의 인기 질문</H5>
      </FlexBox>

      <ToggleButton
        tabs={tabs}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />
      {/* Stats list */}
      <Stack spacing={1} paddingTop={'16px'}>
        {data.map((item, index) => (
          <Box
            key={index}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              cursor: 'pointer',
            }}
            onClick={() => navigate(item.path || '')}
          >
            <Small
              sx={{
                fontSize: '16px',
                color: '#333333',
                fontWeight: 500,
                flex: 1,
                marginRight: '12px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {item.question}
            </Small>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Box marginRight={'4px'} marginTop={'4px'}>
                <ThumbsUp size={18} color={theme.palette.primary.greytxt} />
              </Box>
              <Typography
                sx={{
                  fontSize: '15px',
                  fontWeight: 500,
                  color: theme.palette.primary.greytxt,
                }}
              >
                {item.likes}
              </Typography>
            </Box>
          </Box>
        ))}
      </Stack>
    </Box>
  );
};

export default MonthlyPopularQuestions;
